import Axios from 'axios';

async function filter(urlkey, searchData)
{
    let url = `https://docsserver.onrender.com/sheets/shareFilter/${urlkey}`;
    let doc = await Axios.get(url);
    //console.log(doc.data);
    if(doc.data.length !== 0)
    {
        let set = doc.data[0].editors.concat(doc.data[0].viewers);
    
        let res = searchData.filter(item => {
            return !set.includes(item._id);
        })
        
        return(res);
    }

    return searchData;

}

export default filter;